module.exports = "<router-outlet></router-outlet><modal-help-component></modal-help-component>";


//////////////////
// WEBPACK FOOTER
// ./src/components/app/app.component.pug
// module id = 1039
// module chunks = 0